module.exports = __webpack_public_path__ + "img/perfectiondetail@2x.1124993.webp";